import { i18n } from './instance'
import common from './locales/pt-BR/common'
import errors from './locales/pt-BR/errors'
import forms from './locales/pt-BR/forms'
import ui from './locales/pt-BR/ui'

type AppResources = Record<string, Record<string, unknown>>

export async function initI18n(appResources: AppResources): Promise<void> {
  await i18n.init({
    lng: 'pt-BR',
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    resources: {
      'pt-BR': {
        common,
        errors,
        forms,
        ui,
        ...appResources,
      },
    },
    interpolation: { escapeValue: false },
  })
}
